import { render, staticRenderFns } from "./PaxInputHorizontal.vue?vue&type=template&id=6bd88039&scoped=true&"
import script from "./PaxInputHorizontal.vue?vue&type=script&lang=js&"
export * from "./PaxInputHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./PaxInputHorizontal.vue?vue&type=style&index=0&id=6bd88039&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd88039",
  null
  
)

export default component.exports